import styled from 'styled-components/macro'
import { device, ColorsMap } from '@/utils/Theme'

export const BrandWrapper = styled.div`
  position: relative;
  height: 1rem;

  > img {
    height: 100%;
    opacity: 0.5;
    transition: 0.3s;
  }
`

export const ProductWrapper = styled.a`
  display: block;
  -webkit-user-drag: none;
  position: relative;
  cursor: pointer;
  min-width: 15rem;
  width: 100%;
  margin: 0.5rem auto;
  margin-left: 0;
  background-color: ${ColorsMap.white};
  padding: 1rem;

  @media (max-width: ${device.mobileS}) {
    width: 100%;
    margin: 0.5rem 0;
  }

  &:hover {
    ${BrandWrapper} > img {
      opacity: 1;
    }
  }
`

export const ProductImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 14rem;
  * {
    max-width: 80%;
    height: auto;
    max-height: 100%;
  }
`
export const DescriptionWrapper = styled.div`
  margin: 1rem;
  max-width: 100%;
  * {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

export const ImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  border: 1px solid;
`

export const Num = styled.div`
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  background-color: ${(props) => (props.controller ? ColorsMap.primary : 'none')};
  color: ${(props) => (props.controller ? ColorsMap.white : 'black')};
  border-radius: 0.25rem;
  margin: 0 0.25rem;
`
export const ShowOrderPart = styled.div<StylesProps>`
  width: 8%;
  height: 0.2rem;
  background-color: ${ColorsMap.textDefault};

  transition: all 1s ease;
  cursor: pointer;
  opacity: ${(props) => {
    return props.activeSlide ? '1' : '0.2'
  }};
`

export const SalePriceWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`

export const Cross = styled.div`
  text-decoration: line-through;
  display: flex;
  align-items: center;
  color: ${ColorsMap.textDefault};
`
